<template>
    <div class="payment">
        <div class="line" v-if='listOrder == 0'>
            <div class="linePayment">线下支付</div>
            <div class="tips">
                <div>1：请上传支付信息。</div>
                <div>2：等待平台审核。</div>
                <div>3：审核通过，还款成功，否则还款失败</div>
            </div>
            <div class="formList">
                <div class="">
                    <div><span>*</span>还款金额</div>
                    <input type="text" v-model="payInput" @input="changeInput" />
                </div>
                <div>
                    <div><span>*</span>描述</div>
                    <input type="text" v-model='describe' />
                </div>
                <div>

                    <div>还款凭证</div>
                    <el-upload class="avatar-uploader" action="https://www.nays.com.cn/center//common/upload"
                        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
                <div class="sortInpt">
                    <div>利息</div>
                    <input type="text" disabled v-model="interest">
                </div>
                <div class="sortInpt">
                    <div>实付款</div>
                    <input type="text" disabled v-model="actualPayment" />（本金+ 利息）
                </div>
            </div>
            <div class="formSubmit" @click="submit(0)">提交</div>
        </div>

        <div class="onLine" v-else>
            <div class="linePayment">在线支付</div>
            <div class="lineForm">
                <div>
                    <span>金额：</span>
                    <input type="text" v-model="payInput" @input="changeInput">
                </div>
                <div>
                    <span>利息：</span>
                    <input type="text"  disabled v-model="interest">
                </div>
                <div>
                    <span>实付款：</span>
                    <input type="text"  disabled v-model="actualPayment">
                </div>
            </div>
            <div class="pay">
                <div @click="getPay(0)" :class="{ 'col': isPay == 0 }"><img
                        src="https://shop.xunyoutest.com/shop/static/src/default/images/zhifubao.png" alt=""></div>
                <div @click="getPay(1)" :class="{ 'col': isPay }"><img
                        src="https://shop.xunyoutest.com/shop/static/src/default/images/weixin.png" alt=""></div>
            </div>
            <div class="paySuccess" @click="submit(1)">
                确认付款
            </div>
        </div>
    </div>
</template>
<script>
import { getDetails, payDetails } from '@/api/xunyou'
export default {
    data() {
        return {
            imageUrl: '',
            listOrder: '',
            isPay: '',
            detailsId: this.$route.query.detailsId,
            detalisList: '',
            payInput: '',
            interest: 0,
            actualPayment: '',
            describe: '',
            isInterest: '',
        }
    },
    created() {
        this.listOrder = this.$route.query.usid
        this.getDetail()
    },
    methods: {
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            console.log(file.type)
            const isJPG = file.type === 'image/jpeg' || 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.warning('上传头像图片只能是 JPG或PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.warning('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        getPay(val) {
            this.isPay = val
        },
        changeInput() {
            this.interest = this.isInterest ? Number(this.payInput) * Number(this.detalisList.rate) * Number(this.detalisList.installmentDays) / 100 : 0
            this.actualPayment = Number(this.payInput) + Number(this.interest)
        },
        getDetail() {
            getDetails({ detailsId: this.detailsId }).then(res => {
                this.detalisList = res.data
                let diff = new Date().getTime() - new Date(this.detalisList.createDime).getTime()
                let nd = 1000 * 24 * 60 * 60;
                this.isInterest = Math.floor(diff / nd)>0?false:true
              
                this.payInput = this.detalisList.amount
                // console.log(diff);
				// 	console.log(nd);
                //  console.log(this.isInterest);
                this.interest = this.isInterest ? Number(this.payInput) * Number(this.detalisList.rate) * Number(this.detalisList.installmentDays) / 100 : 0
                this.actualPayment = Number(this.payInput) + Number(this.interest)
          
                console.log(this.isInterest,'isInterest')
                console.log(this.interest,'this.interestthis.interest')
            })
        },
        submit(val) {  //白条付款
            const arr = {
                amount: this.payInput,
                credentials: this.imageUrl,
                describe: this.describe,
                detailsId: this.detailsId,
                interest: this.interest,
                realPayment: this.actualPayment,
                type: val,
            }
            payDetails(arr).then(res => {
                if (res.data.code==0) {
                    this.$message({
                        message: '已提交，请等待审核通过',
                        type: 'success'
                    });
                    this.$router.push('/myStripe');    //跳转我的白条页面
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.payment {
    padding: 0 27px;

    .linePayment {
        font-size: 30px;
        font-weight: 400;
        line-height: 68px;
        color: #757575;
        border-bottom: 1px solid #eaeaea;
    }
}

.formList {
    >div {
        display: flex;
        margin-top: 10px;

        div {
            width: 140px;
        }
    }

    div {
        font-size: 14px;

        span {
            color: red;
        }
    }

    input {
        flex: 1;
        height: 30px;
        outline: none;
        border: 1px solid #e4e4e4;
        padding-left: 5px;

        &:focus {
            border-color: #ff6700;
            box-shadow: 0 0 4px #ff6700;
            transition: all .3s;
        }
    }
}

.sortInpt {
    input {
        width: 220px;
        flex: 0;
    }
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 110px;
    height: 110px;
    line-height: 110px;
    text-align: center;
    border: 1px solid #e4e4e4;
}

.avatar {
    width: 110px;
    height: 110px;
    display: block;
}

.formSubmit {
    margin-top: 20px;
    color: #fff;
    background-color: #ff6700;
    border-color: #e65d00;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    cursor: pointer;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857;
    border-radius: 0;
}

.lineForm {
    div {
        margin-top: 10px;

        span {
            display: inline-block;
            width: 60px;
        }

        input {
            height: 30px;
            outline: none;
            border: 1px solid #e4e4e4;
            padding-left: 5px;

            &:focus {
                border-color: #ff6700;
                box-shadow: 0 0 4px #ff6700;
                transition: all .3s;
            }
        }
    }
}

.pay {
    display: flex;
    flex-direction: column;
    width: 300px;
    margin-top: 10px;

    div {
        width: auto;
        display: inline-block;
        height: 70px;
        line-height: 70px;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 0 50px;
        margin-bottom: 20px;

        img {
            width: 140px;
        }
    }
}

.paySuccess {
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    touch-action: manipulation;
    cursor: pointer;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857;
    border-radius: 0;
    color: #fff;
    background-color: #ff6700;
    border-color: #e65d00;
}

.col {
    border: 1px solid #3399ff !important;
}
</style>


// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/payment.vue